import * as React from "react";
import { useHistory } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import {
  Box,
  Tooltip,
  Typography,
  Toolbar,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import WalletIcon from "@mui/icons-material/Wallet";
import MenuIcon from "@mui/icons-material/Menu";
import OutsideClickHandler from "react-outside-click-handler";
import { Images } from '../../assets/common';
import {
  getUserDetail,
  logout,
  getUserId,
  fullName,
  truncate,
  updateUserDetail, isOwnerId,
} from '../../constants/function';
import "./index.scss";
import Balance from "../Balance";
import ProfileMenu from "../ProfileMenu";
import Notifications from "../../pages/Notifications";
import Search from "../../pages/Search";
import ApiService from "./../../services/api-service";
import { useDispatch, useSelector } from "react-redux";
import { clearSong } from "../../action/songs";
import { getErrorString } from "./../../constants/function";
import { useContext } from "react";
import { SocketContext } from "../../context/socket";
import { hideChat } from "./../../action/chat";
import * as io from "socket.io-client";
import { SERVER_URL } from "./../../constants/api";
import cookieStorage from "../../services/cookie-storage";
import { startStream } from "../../action/stream";
import { useTranslation } from "react-i18next";
import Geocode from "react-geocode";
import { Close } from "@mui/icons-material";
import ProfileBorder from "./ProfileBorder";
import { getBalance } from "../../asyncAction/asyncBalance";
import { Flags } from 'react-feature-flags';
import StreamHeader from '../Stream/AudiencCardContainer/StreamHeader';
import emitter from '../../EventEmitter';

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_KEY);
Geocode.setLanguage("en");

export default function Header({ currentScreenWidth,
  isJoined, tokenData, songData,
  toggleNav, isChatOpen, setIsChatOpen, isFullScreen }) {
  const { t, i18n } = useTranslation("common");
  const {
    streamData,
    obs,
  } = useSelector((state) => state.stream);

  const token = cookieStorage.getCookie("Authorization");
  const userId = getUserId();
  const { Socket, setSocket } = useContext(SocketContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const userDetail = getUserDetail();
  const [showNotification, setShowNotification] = React.useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = React.useState(false);
  const [unreadCount, setUnreadCount] = React.useState(0);
  const [msgs, setMsgs] = React.useState([]);
  const [showSearchBar, setShowSearchBar] = React.useState(true);
  const [isLongSearchBar, setIsLongSearchBar] = React.useState(true);
  const [showWalletButtons, setShowWalletButtons] = React.useState(true);
  const [isStreaming, setIsStreaming] = React.useState(false);
  const isOpen = React.useRef(null);
  const [isOwner, setIsOwner] = React.useState(false);

  const handleProfileClick = (event) => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const handleProfileClose = () => {
    setIsProfileMenuOpen(false);
  };

  const handleProfileMenuChoice = (key) => {
    handleProfileClose();
    switch (key) {
      case "m11":
          emitter.emit( "hideStream" );
          history.push("/app/Profile");
        break;
      case "m12":
        emitter.emit( "hideStream" );
        history.push("/app/Analytics");
        break;
      case "m13":
        emitter.emit( "endtream" );
        Socket.close();
        setSocket(null);
        dispatch(clearSong());
        logout();
        history.push("/");
        break;
      default:
        break;
    }
  };

  const markSeen = async (path, notificationId, seen) => {
    history.push(path);
    if (!seen) {
      try {
        await ApiService.MARK_SEEN({
          notificationId: notificationId,
          status: "seen",
        });
      } catch (error) {
      }
    }
  };

  const getUnreadCount = async () => {
    try {
      const response = await ApiService.UNREAD();
      if (response["result"][0]) {
        setUnreadCount(response["result"][0]["count_unread_notifications"]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateUserDetails = async () => {
    try {
      const response = await ApiService.USER_PROFILE();
      localStorage.setItem(
        "streamingBalance",
        response.result.streamingBalance
      );
      updateUserDetail(response["result"]);
    } catch (error) {
    }
  };

  React.useEffect(() => {
    setIsOwner( isOwnerId(streamData?.owner) );
    getUnreadCount();
    if (userDetail && !userDetail.hasPremium) updateUserDetails();
    if (token && !Socket)
      setSocket(
        io.connect(SERVER_URL, {
          auth: { JWT: token },
          transports: ["websocket"],
          reconnection: true,
        })
      );
    if (!userDetail.country) {
      getLocation();
    }
  }, [streamData]);

  function getLocation() {
    if (navigator.geolocation) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
      }
    }
  }

  function showPosition(position) {
    Geocode.fromLatLng(
      position.coords.latitude,
      position.coords.longitude
    ).then(
      (response) => {
        let country;
        for (
          let i = 0;
          i < response.results[0].address_components.length;
          i++
        ) {
          for (
            let j = 0;
            j < response.results[0].address_components[i].types.length;
            j++
          ) {
            switch (response.results[0].address_components[i].types[j]) {
              case "country":
                country = response.results[0].address_components[i].long_name;
                break;
            }
          }
        }
        if (country) {
          country
            .toLowerCase()
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

          updateProfile(country);
        }
      },
      (error) => {
        console.error(error);
      }
    );

    const updateProfile = async (country) => {
      try {
        const formData = new FormData();
        formData.append("country", country);
        const response = await ApiService.UPDATE_USER(formData);
        updateUserDetail(response["result"]);
      } catch (error) {
        console.log(getErrorString(error));
      }
    };
  }

  const getPlaylistDetail = async (channelName) => {
    try {
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: channelName,
        pageNo: 1,
        pageSize: 1,
      });
      dispatch(
        startStream({
          streamData: response?.result,
          title: null,
          goal: null,
        })
      );
    } catch (error) {
    }
  };

  React.useEffect(() => {
    // Browser notification for new message
    //NOTE:safari issue
    // if (!Notification) {
    //   alert(
    //     "Desktop notifications not available in your browser. Try Chromium."
    //   );
    //   return;
    // }
    // if (Notification.permission !== "granted") Notification.requestPermission();
    if (Socket) {
      Socket.on("message_received", (msg) => {
        if (msg["senderUserId"] === userId) {
          const m = msgs;
          m.push(msg);
          setMsgs([...m]);
          // Browser notification
          // if (!isOpen.current) {
          //   var notification = new Notification(
          //     `New message from ${msg["user"]["firstName"]}`,
          //     {
          //       icon:
          //         msg["user"]["profileImg"] &&
          //         msg["user"]["profileImg"]["filePath"]
          //           ? msg["user"]["profileImg"]["filePath"]
          //           : Images.user_dummy,
          //       body: truncate(msg["message"], 25),
          //     }
          //   );
          //   notification.onclick = function () {
          //     setMsgs([]);
          //     handleOpenChat();
          //   };
          // }
        }
      });

      Socket.on("update-balance", function(data) {
        if (data.update) {
          dispatch(getBalance());
        }
      });

      Socket.on("balanceUpdated", function(data) {
        if (data?.result?._id === userId) {
          dispatch(getBalance());
        }
      });

      //   //Showing notification to followers if user start livestream
      //   // Socket.on("stream-joined", function (data) {
      //   //   if (data && data.followers && data.followers.length > 0 && !isStream) {
      //   //     const index = data.followers.indexOf(userId);
      //   //     if (index >= 0) {
      //   //       const fullname = fullName(data);
      //   //       var notification = new Notification(` ${fullname} has gone live`, {
      //   //         icon: data?.profileImg?.filePath || Images.streaming,
      //   //         // body: "Click to join the live streaming",
      //   //       });
      //   //       // notification.onclick = function () {
      //   //       //   getPlaylistDetail(data.channelName);
      //   //       // };
      //   //     }
      //   //   }
      //   // });
    }
    // 1080p_5
  }, [Socket]);

  const handleOpenChat = () => {
    // if (msgs.length > 0) {
    //   const userName = fullName(msgs[0]['user']);
    //   const userid = msgs[0]['user']['_id'];
    //   setChatOpen({ userid: userid, userName: userName })
    // } else {
      emitter.emit( "hideStream" );
      setIsChatOpen(true);
    // }
  };

  React.useEffect(() => {
    if (isChatOpen) {
      setMsgs([]);
    }
    isOpen.current = isChatOpen;
  }, [isChatOpen]);

  React.useEffect(() => {
    setIsStreaming( tokenData?.token );
    setShowSearchBar( currentScreenWidth > 800 || ( !tokenData?.token && currentScreenWidth > 600 ) );
    setIsLongSearchBar( currentScreenWidth > 800 );
    setShowWalletButtons( !tokenData?.token && currentScreenWidth > 800 );
  }, [currentScreenWidth,tokenData]);

  return (
      <Box id="headerBox"
      sx={{
        background: "black",
        flexGrow: 1,
        height: "60px",
        display: "flex",
        alignItems: "center",
        boxShadow: "0px 3px 6px #00000029",
        position: "fixed",
        width: "100%",
        top: 0,
        zIndex: 1300
      }}
      className="__app_header"
    >
      <AppBar id="appBar"
        sx={{
          background: "transparent",
          boxShadow: "none",
          position: "fixed",
          top: 0,
          zIndex: 1400
        }}
          >

          <Toolbar>
            { currentScreenWidth > 600 ? null : (
                <Tooltip title="Open navigation menu">
                  <IconButton
                      size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={toggleNav}
              >
                <MenuIcon />
              </IconButton>
            </Tooltip>
          )}

          <Box 
            id="appLogo"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Flags 
              authorizedFlags={["v3-full", "v3-navBar"]}
              renderOn={() =>
                <img 
                  src={require('../../assets/common/resources/SIKI_Beta.png')} // Directly reference the image path
                  alt="SIKI Logo"
                  onClick={() => emitter.emit("goHome")}
                  className="___header_logo _cp"
                  style={{ cursor: "pointer", height: "40px" }} // Adjust height as needed
                />
              }
              renderOff={() =>
                <img 
                  src={require('../../assets/common/resources/SIKI_Beta.png')} // Directly reference the image path
                  alt="SIKI Logo"
                  onClick={() => emitter.emit("goHome")}
                  className="___header_logoV2 _cp"
                  style={{ cursor: "pointer", height: "40px" }} // Adjust height as needed
                />
              }
            />
          </Box>


            <Flags authorizedFlags={["v3-full", "v3-liveFull"]}
                   renderOn={ () =>
                       isStreaming ? (
                       <StreamHeader
                           title={streamData?.title}
                  isOwner={isOwner}
                  isJoined={isJoined}
                  playlistId={streamData._id}
                  streamSong={songData}
                  obs={obs}
                  isFullScreen={isFullScreen}
                />
              ) : null
            }
          />

          <Box id="searchBox"
            sx={{
              display: "flex",
              flexGrow: 1,
              alignItems: "center",
              justifyContent: 'flex-end',
                 }}
            >

              { !showSearchBar ? (
                  <IconButton onClick={() => {
                    setShowSearchBar(true);
                  }}>
                    <SearchIcon />
                  </IconButton>
              ) : null }

              { showSearchBar && isLongSearchBar ? <Search /> : null }

              { showSearchBar && !isLongSearchBar ? (
                  <Box
                      sx={{
                        display: "flex",
                  alignItems: "center",
                }}
              >
                <Search
                  showClose={
                    <IconButton onClick={() => {
                      setShowSearchBar(false);
                    }}>
                      <Close />
                    </IconButton>
                        }
                    />
                  </Box>
              ) : null }
            </Box>

            <Box id="iconBar"
            className="__header_left_items"
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <IconButton
              id="chatIcon"
              onClick={() => {
                setMsgs([]);
                handleOpenChat();
                dispatch(hideChat(true));
              }}
            >
              <img
                sx={{ mx: "10px" }}
                src={Images.chat}
                alt="chat"
              />
            </IconButton>

            {msgs.length > 0 && !isChatOpen ? (
              <Box id="chatActive"
                sx={{
                  position: "absolute",
                  width: "9px",
                  height: "9px",
                  background: "#F20606",
                  right: "7px",
                  bottom: "7px",
                  borderRadius: "50%",
                }}
              ></Box>
            ) : null}

            <IconButton
              id="notificationIcon"
              onClick={() => setShowNotification(!showNotification)}
            >
              <img
                src={
                  unreadCount > 0
                    ? Images.notification
                    : Images.notification_without_dot
                }
                sx={{ mx: "10px" }}
                alt="notifications"
                />
              </IconButton>

              { showWalletButtons ? (
                  <Balance className="_cp" />
              ) : (
                  <IconButton onClick={() => {
                      emitter.emit( "hideStream" );
                      history.push("/app/Wallet" )
                  }}>
                      <WalletIcon />
                  </IconButton>
              ) }

                <Box
                      id="userProfileIcon"
              onClick={handleProfileClick}
              className="_cp"
              sx={{
                position: "relative",
              }}
            >
              <ProfileBorder
                        progress={userDetail["percentage"]}
                        style={{ position: "relative" }}
                    />
                    { /* TODO: https://siki.atlassian.net/browse/SK-335 */ }
                    <img
                        style={{
                          zIndex: -10,
                  objectFit: "cover",
                  position: "absolute",
                  width: "42px",
                  height: "37px",
                  top: "12px",
                  right: "24px",
                  clipPath:
                    "polygon(25% 0%, 75% 0%, 100% 50%, 75% 99%, 25% 99%, 0% 50%)",
                  backgroundColor: "#1e1e1e",
                }}
                src={
                  userDetail["profileImg"] &&
                    userDetail["profileImg"]["filePath"] != ""
                    ? userDetail["profileImg"]["filePath"]
                    : ""
                }
                alt="user profile"
              />
            </Box>
          </Box>

        </Toolbar>
      </AppBar>

      {isProfileMenuOpen ? (
        <OutsideClickHandler
          onOutsideClick={() => {
            handleProfileClose();
          }}
        >
          <ProfileMenu
            isLast={"65px !important"}
            right={"0px"}
            actions={[
              { key: "m11", action: t("dropMenu.m11") },
              { key: "m12", action: t("dropMenu.m12") },
              { key: "m13", action: t("dropMenu.m13") },
            ]}
            handleProfileMenuChoice={(item) => handleProfileMenuChoice(item)}
            handleClick={() => handleProfileClose()}
          />
        </OutsideClickHandler>
      ) : null}

      {showNotification ? (
        <OutsideClickHandler onOutsideClick={() => setShowNotification(false)}>
          <Notifications
            onClick={(path, id, seen) =>
              path ? (setShowNotification(false), markSeen(path, id, seen)) : ""
            }
            notificationShow={setShowNotification}
            setUnreadCnt={setUnreadCount}
            unreadCnt={unreadCount}
            openChat={(e) => {
              setMsgs([]);
              handleOpenChat();
            }}
          />
        </OutsideClickHandler>
      ) : null}
    </Box>
  );
}


